var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { openAuthModal } from "../actions/auth/creators/Login";
var SignIn = /** @class */ (function (_super) {
    __extends(SignIn, _super);
    function SignIn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.componentDidMount = function () {
            _this.props.openAuthModal();
            _this.props.history.push('/');
        };
        return _this;
    }
    SignIn.prototype.render = function () {
        return _jsx("h1", { children: "SignIn" });
    };
    return SignIn;
}(React.Component));
export default withRouter(connect(function (s) { return s; }, { openAuthModal: openAuthModal })(SignIn));



// WEBPACK FOOTER //
// ./src/containers/SignIn.js